import React from 'react';

function Wip () {
  return (
    <h1 className="wip">Work in Progress.</h1>
  );
}

export default Wip;
